(function () {
    'use strict';

    angular
        .module('app')
        .controller('WorkflowHomeCtrl', WorkflowHomeCtrl);

    WorkflowHomeCtrl.$inject = ['ChilliUserProfileService', 'WindowTitleService'];

    function WorkflowHomeCtrl(ChilliUserProfileService, WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.permissionDenied = false;

        activate();

        function activate() {
            WindowTitleService.setTitle('Workflows');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsNotAdmin: function () {
                    vm.permissionDenied = true;
                },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });
        }
    }
})();
